import React from 'react';
import { X, Activity, Droplets, BrainCircuit } from 'lucide-react';
export function MechanismReveal() {
  const failures = [{
    tried: 'Dietas de restricción calórica',
    why: 'Aumentan el cortisol → más inflamación'
  }, {
    tried: 'Batidos detox y ayunos',
    why: 'Estresan el hígado sin dirección'
  }, {
    tried: 'Pastillas para el vientre',
    why: 'Tratan el síntoma, no el origen'
  }, {
    tried: 'Más ejercicio',
    why: 'Sin base antiinflamatoria, genera más fatiga'
  }, {
    tried: 'Suplementos random',
    why: 'Sin protocolo, el cuerpo no los procesa bien'
  }];
  return <section className="bg-brand-dark py-20 px-4 sm:px-6 lg:px-8 text-white" data-id="element-207">
      <div className="max-w-4xl mx-auto" data-id="element-208">
        <div className="text-center mb-12" data-id="element-209">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-brand-gold mb-4" data-id="element-210">
            La razón real por la que nada ha funcionado hasta ahora
          </h2>
          <p className="text-xl sm:text-2xl font-sans font-medium text-gray-300" data-id="element-211">
            No es lo que comes. Es lo que tu biología interpreta.
          </p>
        </div>

        <div className="bg-white/5 rounded-2xl border border-white/10 overflow-hidden mb-16" data-id="element-212">
          <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-white/10" data-id="element-213">
            <div className="p-6 bg-brand-red/10" data-id="element-214">
              <h3 className="text-xl font-bold mb-6 text-center text-brand-red" data-id="element-215">
                Lo que has intentado
              </h3>
              <ul className="space-y-4" data-id="element-216">
                {failures.map((f, i) => <li key={i} className="flex items-center text-gray-300" data-id="element-217">
                    <X className="w-5 h-5 text-brand-red mr-3 flex-shrink-0" data-id="element-218" />
                    <span data-id="element-219">{f.tried}</span>
                  </li>)}
              </ul>
            </div>
            <div className="p-6" data-id="element-220">
              <h3 className="text-xl font-bold mb-6 text-center text-brand-gold" data-id="element-221">
                Por qué no funciona
              </h3>
              <ul className="space-y-4" data-id="element-222">
                {failures.map((f, i) => <li key={i} className="flex items-center text-gray-300" data-id="element-223">
                    <span className="w-2 h-2 bg-brand-gold rounded-full mr-4 flex-shrink-0" data-id="element-224"></span>
                    <span data-id="element-225">{f.why}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center space-y-8" data-id="element-226">
          <h3 className="text-3xl sm:text-4xl font-serif font-bold text-white" data-id="element-227">
            El Reinicio Biológico: el protocolo que va al origen
          </h3>

          <div className="prose prose-lg prose-invert mx-auto text-gray-300 text-[17px] sm:text-[18px]" data-id="element-228">
            <p data-id="element-229">
              El Reinicio Biológico no es una dieta. Es un protocolo técnico de
              14 días diseñado para apagar los{' '}
              <strong data-id="element-230">3 interruptores biológicos</strong> que mantienen tu
              cuerpo en modo inflamatorio.
            </p>
            <p data-id="element-231">
              Cuando los 3 interruptores se apagan en el orden correcto, el
              cuerpo deja de retener líquidos, el vientre se descomprime, la
              energía vuelve y la mente se aclara.
            </p>
            <p className="text-brand-gold font-medium text-xl mt-6" data-id="element-232">
              Sin pasar hambre. Sin gimnasio. Sin suplementos caros.
            </p>
            <p data-id="element-233">Solo con lo que ya tienes en casa y un orden específico.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12" data-id="element-234">
            <div className="bg-white/5 p-6 rounded-xl border border-brand-gold/30 flex flex-col items-center text-center" data-id="element-235">
              <div className="w-16 h-16 bg-brand-gold/20 rounded-full flex items-center justify-center mb-4" data-id="element-236">
                <Activity className="w-8 h-8 text-brand-gold" data-id="element-237" />
              </div>
              <h4 className="font-bold text-lg mb-2 text-white" data-id="element-238">
                Interruptor 1
              </h4>
              <p className="text-gray-400" data-id="element-239">Inflamación intestinal</p>
            </div>
            <div className="bg-white/5 p-6 rounded-xl border border-brand-gold/30 flex flex-col items-center text-center" data-id="element-240">
              <div className="w-16 h-16 bg-brand-gold/20 rounded-full flex items-center justify-center mb-4" data-id="element-241">
                <Droplets className="w-8 h-8 text-brand-gold" data-id="element-242" />
              </div>
              <h4 className="font-bold text-lg mb-2 text-white" data-id="element-243">
                Interruptor 2
              </h4>
              <p className="text-gray-400" data-id="element-244">Cortisol elevado</p>
            </div>
            <div className="bg-white/5 p-6 rounded-xl border border-brand-gold/30 flex flex-col items-center text-center" data-id="element-245">
              <div className="w-16 h-16 bg-brand-gold/20 rounded-full flex items-center justify-center mb-4" data-id="element-246">
                <BrainCircuit className="w-8 h-8 text-brand-gold" data-id="element-247" />
              </div>
              <h4 className="font-bold text-lg mb-2 text-white" data-id="element-248">
                Interruptor 3
              </h4>
              <p className="text-gray-400" data-id="element-249">Señales hormonales confundidas</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}